export default __webpack_public_path__ + "static/bgtestimonials-b007f8eb284b374d0318c478c67772d0.svg";